import { cachedApi } from "../../services/cachedApi";

const useQueues = () => {
	const findAll = async () => {
        return await cachedApi.queues.findAll();
    }

	return { findAll };
};

export default useQueues;
